module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeftLight--dark-b87ce877be47d7fa5f1b1fc85fbe73b8.png";